import React, { useState, useEffect } from "react";
import { db } from "../../firebaseconf";
import { collection, query, where, getDocs } from "firebase/firestore";
import Layout from "../../components/layout";
import Header from "../../components/header";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { COLLEGE_SEMESTERS } from "../../utils/semesterDefaults";

export default function Sessionals() {
    const [student, setStudent] = useState(null);
    const [semesters, setSemesters] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState('');
    const [subjects, setSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState('');

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
        if (!loggedUser || !loggedUser.institution_id) return;
        
        // Set student data from logged user
        setStudent(loggedUser);
        
        // Fetch semesters from subjects collection
        const subjectsRef = collection(db, 'institutions', loggedUser.institution_id, 'subjects');
        const subjectsSnapshot = await getDocs(subjectsRef);
        
        if (subjectsSnapshot.empty) {
          setSemesters(COLLEGE_SEMESTERS);
        } else {
          const uniqueSemesters = [...new Set(subjectsSnapshot.docs.map(doc => doc.data().semester))];
          setSemesters(uniqueSemesters.length > 0 ? uniqueSemesters : COLLEGE_SEMESTERS);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchStudentData();
  }, []);

  useEffect(() => {
    if (selectedSemester) {
      const fetchSubjects = async () => {
        try {
          const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
          if (!loggedUser || !loggedUser.institution_id) return;
          
          const q = query(
            collection(db, 'institutions', loggedUser.institution_id, 'subjects'),
            where('semester', '==', selectedSemester)
          );
          const snapshot = await getDocs(q);
          const subjectsData = snapshot.docs.map(doc => doc.data().name || doc.data().subject_name);
          setSubjects(subjectsData);
        } catch (error) {
          console.error('Error fetching subjects:', error);
        }
      };
      fetchSubjects();
    }
  }, [selectedSemester]);

    return (
        <Layout>
            <Header title="View My Sessionals" />
            <Box sx={{ p: 2 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: isSmallScreen ? 'column' : 'row',
                        justifyContent: 'start',
                        gap: 5,
                        mb: 3,
                    }}
                >
                    <FormControl fullWidth={isSmallScreen} sx={{ minWidth: 200 }}>
                        <InputLabel id="semester-label">Select Semester</InputLabel>
                        <Select
                            labelId="semester-label"
                            id="semester"
                            value={selectedSemester}
                            onChange={(e) => setSelectedSemester(e.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {semesters.map((semester) => (
                                <MenuItem key={semester} value={semester}>{semester}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {subjects.length > 0 && (
                        <FormControl fullWidth={isSmallScreen} sx={{ minWidth: 200 }}>
                            <InputLabel id="subject-label">Select Sessional</InputLabel>
                            <Select
                                labelId="subject-label"
                                id="subject"
                                value={selectedSubject}
                                onChange={(e) => setSelectedSubject(e.target.value)}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {subjects.map((subject) => (
                                    <MenuItem key={subject} value={subject}>{subject}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Box>

                {selectedSubject && student && (
                    <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Roll Number</TableCell>
                                    <TableCell>Semester</TableCell>
                                    <TableCell>Subject</TableCell>
                                    <TableCell>Marks</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>{student.name || 'N/A'}</TableCell>
                                    <TableCell>{student.roll_number || 'N/A'}</TableCell>
                                    <TableCell>{selectedSemester}</TableCell>
                                    <TableCell>{selectedSubject}</TableCell>
                                    <TableCell>-</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </Layout>
    );
}
